import { CarRefItemStatus } from "../constants/car-basic-data";


export class CarFeature {
    id: number = 0;
    
    code = '';
    name = '';
    details = '';

    status: CarRefItemStatus = CarRefItemStatus.REVIEW;
    created = '';
    lastUpdated = '';
    lastUpdatedBy = '';
  
    constructor (code: string, name: string)  {
        this.code = code!;
        this.name = name!;
    }
  }
  